import { api } from '@/services';
import { BusinessError, unwrap } from '@/api/envelope';
import type {
  ContarCteEmalotePayload,
  ContarDocumentosEmaloteResponse,
  ContarNfcEmalotePayload,
  ContarNfeEmalotePayload,
} from '../types';

/**
 * A recusa vem em HTTP 200 com `resultado: false` e `data: null`. Lida como sucesso, ela virava
 * "Total: 0" no selo: a tela afirmava que o E-Malote não tinha nota nenhuma (LC-11).
 */
function quantidadeDaContagem(resposta: ContarDocumentosEmaloteResponse): number {
  const { data } = unwrap(resposta);
  if (typeof data?.qtd !== 'number') {
    throw new BusinessError('A contagem do E-Malote veio sem o número.');
  }
  return data.qtd;
}

export async function fetchContarNfeEmalote(payload: ContarNfeEmalotePayload): Promise<number> {
  return quantidadeDaContagem(
    await api.post<ContarDocumentosEmaloteResponse, ContarNfeEmalotePayload>(
      'Documento/ContarNFE',
      payload
    )
  );
}

export async function fetchContarNfcEmalote(payload: ContarNfcEmalotePayload): Promise<number> {
  return quantidadeDaContagem(
    await api.post<ContarDocumentosEmaloteResponse, ContarNfcEmalotePayload>(
      'Documento/ContarNFC',
      payload
    )
  );
}

export async function fetchContarCteEmalote(payload: ContarCteEmalotePayload): Promise<number> {
  return quantidadeDaContagem(
    await api.post<ContarDocumentosEmaloteResponse, ContarCteEmalotePayload>(
      'Documento/ContarCTE',
      payload
    )
  );
}
